import styled from 'styled-components';
import { palette } from '../../theme/colors';
import { toRem } from '../../utils/toRem';

export const STab = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${palette.tinyBorder};
  padding: 1rem 0;
  width: 100%;
  text-decoration: none;

  p {
    flex-grow: 1;
    font-family: 'Roboto-Regular';
    font-size: 1rem;
    color: ${palette.white};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;

export const SRowContainers = styled.div`
  color: ${palette.white};
  display: flex;
  align-items: center;
`;

export const SIcon = styled.img`
  vertical-align: text-bottom;
  &.icon {
    width: 1.2rem;
    margin-right: ${toRem(10)};
  }
  &.arrow {
    padding-right: ${toRem(9)};
    height: ${toRem(20)};
  }
`;
